import { computedFrom } from 'aurelia-binding';
import { HttpClient } from 'aurelia-fetch-client';
import { autoinject } from 'aurelia-framework';
import 'whatwg-fetch';
import { ApiResponse } from '../models/api-response';
import { ServiceResponse } from '../models/service-response';
import { State } from './global-state';
import { HPFServiceClient } from './hpfApi';

@autoinject
export class HpfPaymentPlanService extends HPFServiceClient {

	constructor(
		state: State,
		http: HttpClient,
	) {
		super(state, http);
	}

	skipPlanPayments(planKey: number, numberOfPayments: number, reason: string) {
		let url = `/paymentPlan/${planKey}/skipPayments`;
		let content = {
			paymentPlanKey: planKey,
			numberOfPayments,
			reason,
		};

		return this.post(url, content);
	}
}
